import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Box, Chip, Grid, Stack, Typography } from "@mui/material";
import { memo, useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import CustomCheckbox from "../../../components/checkbox";
import Label from "../../../components/label";
import TextInput from "../../../components/textInput";
import { AppContext } from "../../../lib/Context";
import { customerBankValidation } from "../../../services/WebUser";
import { handleOpenSnackBar } from "../../../utils/helper";
import GlobalButton from "./../../../components/button/index";

const DebitDetails = ({ type }) => {
  const {
    userData,
    isReqDebitDetail,
    setIsReqDebitDetail,
    debitDetails,
    setDebitDetails,
    isBankDetailsVerified,
    setIsBankDetailsVerified,
  } = useContext(AppContext);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const isAdmin = userData?.designation === "Admin" ? true : false;
  const isDetailPage = location.pathname === "/prospect-details";

  const handleChangeValue = (e) => {
    const { name, value } = e.target;

    const formattedValue = value.replace(/\b[a-zA-Z]/g, (char) =>
      char.toUpperCase()
    );
    // setDebitDetails((prev) => ({ ...prev, [name]: formattedValue }));

    setDebitDetails((prev) => {
      const updatedDetails = { ...prev, [name]: formattedValue };

      if (
        isBankDetailsVerified &&
        (name === "accountNumber" || name === "shortCode") &&
        prev[name] !== formattedValue
      ) {
        setIsBankDetailsVerified(false);
      }

      return updatedDetails;
    });
  };

  const handleCheckvalidateBankDetail = async () => {
    if (isLoading) return;

    if (!debitDetails?.accountNumber || !debitDetails?.shortCode) {
      return handleOpenSnackBar(
        "error",
        "Account number or sort code is missing"
      );
    }

    try {
      const payload = {
        accountNumber: debitDetails?.accountNumber,
        sortCode: debitDetails.shortCode,
      };
      setIsLoading(true);
      const response = await customerBankValidation(payload);
      if (response?.data?.status === "success") {
        const data = response.data.data;
        if (data?.IsCorrect === "True") {
          setIsBankDetailsVerified(true);
          handleOpenSnackBar("success", response?.data?.message);
        } else {
          handleOpenSnackBar("error", "Debit details not verified");
        }
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box mt={2} mb={5}>
      <Typography variant="h6" color={"text.charcoalGrey"}>
        Add Direct Debit Details.
      </Typography>

      {isAdmin && (
        <Stack
          direction={"row"}
          alignItems={"center"}
          spacing={4}
          mt={1}
          mb={2}
        >
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            <CustomCheckbox
              isChecked={isReqDebitDetail.yes}
              handleChecked={() => {
                if (!isDetailPage) {
                  setIsReqDebitDetail({
                    yes: true,
                    no: false,
                  });
                }
              }}
            />
            <Typography>Yes</Typography>
          </Stack>
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            <CustomCheckbox
              isChecked={isReqDebitDetail.no}
              handleChecked={() => {
                if (!isDetailPage) {
                  setIsReqDebitDetail({
                    yes: false,
                    no: true,
                  });
                }
              }}
            />
            <Typography>No</Typography>
          </Stack>
        </Stack>
      )}

      {isReqDebitDetail.no === true && (
        <Grid container>
          <Grid item xs={12} sm={6} md={4}>
            <Label title={"Payment Processing Fee"} />
            <TextInput variant={"filled"} value={7} readonly />
          </Grid>
        </Grid>
      )}

      {isReqDebitDetail.yes === true && (
        <>
          <Stack direction={"row"} alignItems={"center"} gap={1}>
            {/* <Typography variant="h6" color={"text.charcoalGrey"}>
              Direct Debit Details
            </Typography> */}
            {isBankDetailsVerified && (
              <Chip
                size="small"
                icon={<CheckCircleOutlineIcon />}
                label={"verified"}
                color="success"
              />
            )}
          </Stack>

          <Grid container mt={isAdmin ? 0 : 2} spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <Label title={"Name of Account Holder"} htmlFor={"holder-name"} />
              <TextInput
                id={"holder-name"}
                required
                type={"text"}
                variant={"filled"}
                value={debitDetails.username}
                name={"username"}
                onChange={handleChangeValue}
                readonly={isDetailPage}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Label
                title={"Account Number (8 digits)"}
                htmlFor={"account-number"}
              />
              <TextInput
                id={"account-number"}
                required
                type={"number"}
                variant={"filled"}
                placeholder={"___ ___ ___ ___ ___ ___ ___ ___"}
                value={debitDetails.accountNumber}
                name={"accountNumber"}
                onChange={handleChangeValue}
                readonly={isDetailPage}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Label title={"Sort Code"} htmlFor={"account-short-code"} />
              <TextInput
                id={"account-short-code"}
                required
                type={"number"}
                variant={"filled"}
                value={debitDetails.shortCode}
                name={"shortCode"}
                onChange={handleChangeValue}
                readonly={isDetailPage}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Label
                title={"Name and Address of Bank/Building Society"}
                htmlFor={"bank-address"}
              />
              <TextInput
                id={"bank-address"}
                required
                type={"text"}
                variant={"filled"}
                value={debitDetails.address}
                name={"address"}
                onChange={handleChangeValue}
                readonly={isDetailPage}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} alignSelf={"flex-end"}>
              <GlobalButton
                variant={"custom_gradient"}
                title={isLoading ? "Verifying...." : "Verify Debit Details"}
                style={{
                  height: 40,
                  width: "auto",
                  borderRadius: 1,
                }}
                handleClickBtn={handleCheckvalidateBankDetail}
              />
            </Grid>
          </Grid>

          {/* <Grid container mt={2} spacing={2}>
            <Grid item xs={12} sm={5} md={3}>
              <Label title={"Sort Code"} htmlFor={"account-short-code"} />
              <TextInput
                id={"account-short-code"}
                required
                type={"number"}
                variant={"filled"}
                value={debitDetails.shortCode}
                name={"shortCode"}
                onChange={handleChangeValue}
                readonly={isDetailPage}
              />
            </Grid>
            <Grid item xs={12} sm={7} md={6}>
              <Label
                title={"Name and Address of Bank/Building Society"}
                htmlFor={"bank-address"}
              />
              <TextInput
                id={"bank-address"}
                required
                type={"text"}
                variant={"filled"}
                value={debitDetails.address}
                name={"address"}
                onChange={handleChangeValue}
                readonly={isDetailPage}
              />
            </Grid>
          </Grid> */}
        </>
      )}
    </Box>
  );
};

export default memo(DebitDetails);
